<div class="attachment-card">
  <div class="attachment-card__thumb">
    <img
      *ngIf="safeThumbnailUrl && !thumbnailFailed"
      [src]="safeThumbnailUrl"
      [alt]="attachment.fileName"
      (error)="onThumbnailError()" />
    <i *ngIf="!safeThumbnailUrl || thumbnailFailed" class="feather" [ngClass]="fileIconClass"></i>
  </div>
  <div class="attachment-card__meta">
    <span class="attachment-card__name" [title]="attachment.fileName">{{ attachment.fileName }}</span>
    <span class="attachment-card__type">
      {{ fileTypeLabel }}<span *ngIf="sizeLabel"> · {{ sizeLabel }}</span>
    </span>
  </div>
  <div class="attachment-card__actions">
    <button type="button" class="attachment-card__btn" (click)="onPreview($event)"
      [attr.aria-label]="'Preview ' + attachment.fileName">
      <i class="feather icon-eye"></i>
    </button>
    <button type="button" class="attachment-card__btn" (click)="onDownload($event)"
      [attr.aria-label]="'Download ' + attachment.fileName">
      <i class="feather icon-download"></i>
    </button>
  </div>
</div>
